import { GtmEventBase  } from '@/services/gtm/common'

export interface GtmSender {
  send(gtmEvent: GtmEventBase): void
}

const removeNullEntries = (obj : any) =>
  Object.entries(obj).reduce<any>((a, [k, v]) => (v == null ? a : ((a[k] = v), a)), {})
  
export const gtmSender: GtmSender = {
  send(gtmEvent : GtmEventBase) {
    //console.log("GTM Event: " + JSON.stringify(removeNullEntries(gtmEvent), undefined, 1))
    window.dataLayer.push(removeNullEntries(gtmEvent))
  }
}

